import styled, { css } from 'styled-components';

export const ArrowDown = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
  width: 7px;
  height: 7px;
  border: 2px solid #aab2b8;
  border-width: 0 2px 2px 0;
  transition: 0.1s all ease-out;
  transform: rotate(45deg);

  top: 50%;
  transform: translateY(-50%) rotate(45deg) ;
  /* transform-origin: center; */
  ${(props) =>
    props.active &&
    css`
      /* top: 18px; */
      transform: rotate(-135deg);
      border-color: #47b972;
    `}
`;

export const Container = styled.div`
  position: relative;
  &.priority {
    min-width: 120px;
    width: 100%;
    margin: 0;
    position: relative;
    li {
      position: relative;
    }
    li::before {
      content: '';
      position: absolute;
      left: 3px;
      top: 50%;
      margin-top: -3.5px;
      border-radius: 50%;
      width: 7px;
      height: 7px;
      background-color: transparent;
    }
    li.critical::before {
      background-color: #ff4747;
    }
    li.info::before {
      background-color: #569056;
    }
    li.notification::before {
      background-color: #ff8322;
    }
  }

  &.vehicle-class {
    min-width: 250px;
    width: 100%;
    margin: 0;
    position: relative;
    li {
      width: 230px;
      position: relative;
    }
    li:hover {
      background-color: #3aa863;
      color: #ffffff;
    }
  }
`;

export const Header = styled.div`
  font-size: 14px;
  padding: 9px 28px 9px 14px;
  background-color: #1a2429;
  color: #e6eaec;
  height: 40px;
  border: solid 1px #3d4952;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  position: relative;
  &::before {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    margin-top: -3.5px;
    border-radius: 50%;
    width: 7px;
    height: 7px;
    background-color: transparent;
  }
  &.critical::before {
    background-color: #ff4747;
  }
  &.info::before {
    background-color: #569056;
  }
  &.notification::before {
    background-color: #ff8322;
  }

  &:hover {
    background-color: #5a626c;
  }
  &.size-sm {
    height: 34px;
    padding: 7px 28px 7px 14px;
  }
`;

export const ListContainer = styled.div`
  position: absolute;
  z-index: 100;
  min-width: 100%;
  width: 100%;
  left: 0;
`;

export const List = styled.ul`
  padding: 4px;
  margin: 5px 0 0;
  list-style: none;
  background-color: #161e23;
  border: 1px solid #3d4952;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: 0 12px 26px 0 rgba(0, 0, 0, 0.5);
  color: #e6eaec;
  font-size: 14px;
  line-height: 1.2;
  overflow: hidden;
`;

export const ListItem = styled.li`
  list-style: none;
  cursor: pointer;
  white-space: nowrap;
  min-height: 1.2em;
  padding: 8px 10px 8px 14px;
  border-radius: 6px;
  transition: background-color 0.12s ease;
  &.active,
  &:hover {
    color: #ffffff;
    background-color: #47b972;
  }
`;
